import { type FC, memo } from "react";
import { Button, ButtonKind, ButtonSize, Text } from "@stubhub/broadway-web";
import { Skeleton } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import {
  calendarBodyOverlay,
  calendarBodyOverlayContent,
  calendarBodyRecipe,
  calendarMonth,
  calendarNavigationHeading,
  calendarTile,
} from "./styles";

const skeletonTileContainer = calendarTile({ mode: "empty", minHeight: "clamped" }).root;

interface Props {
  showNoResults?: boolean;
  resetFilters: () => void;
}

export const CalendarSkeleton: FC<Props> = memo(({ showNoResults, resetFilters }) => {
  const days = Array.from({ length: 14 }, (_, i) => i);
  return (
    <div className={calendarMonth} role="presentation" aria-hidden>
      <Skeleton className={calendarNavigationHeading} width="200px" height="24px" />
      <div className={calendarBodyRecipe({ skeleton: "skeleton" })}>
        {days.map((day) => (
          <div key={day} className={skeletonTileContainer}>
            <Skeleton width="100%" height="100%" />
          </div>
        ))}
      </div>
      {showNoResults && (
        <div className={calendarBodyOverlay}>
          <div className={calendarBodyOverlayContent}>
            <Text variant="label" size="medium">
              <Content id="cid$#4000951#" /> {/* No events within your filters. */}
            </Text>
            <Button kind={ButtonKind.Neutral} size={ButtonSize.Small} onClick={resetFilters}>
              {/* "Reset filters" */}
              <Content id="cid$#3637096#" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
});
CalendarSkeleton.displayName = "CalendarSkeleton";
